
/* styles */
require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader!../../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-abb950da\",\"scoped\":false,\"hasInlineConfig\":false}!less-loader!../../../vue-loader/lib/selector?type=styles&index=0!./touchRipple.vue")

var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./touchRipple.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-abb950da\"}!../../../vue-loader/lib/selector?type=template&index=0!./touchRipple.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/muse-ui/src/internal/touchRipple.vue
// module id = 73
// module chunks = 1